import React from "react";
import Umbrella from "../components/Umbrella";
import InfoGameSpandigi from "../components/InfoGameSpandigi";
import Star from "../components/Star";
import Mountain from "../components/Mountain";
import Game1 from "../static/images/component_svg/Game1.svg";
import Game2 from "../static/images/component_svg/Game2.svg";
import Game5 from "../static/images/component_svg/Game5.svg";
import FingerPoint from "../static/images/component_svg/fingerPoint.svg";
import brain from "../static/images/component_svg/brain.svg";
import digitalBackward from "../static/images/component_svg/digiBackward.svg";
import cube from "../static/images/component_svg/cube.svg";
import wisdom from "../static/images/component_svg/wisdom.svg"
import styles from "./gamecontainer.module.css";

export const GameData = [
  {
    gameNameTH: "การทดสอบเวลาปฎิกิริยาแบบมีตัวเลือก",
    gameNameEng: "Choice reaction time test",
    gamePic: <Umbrella color={"#F36621"} />,
    gameTarget: [
      "Alertness วัดปฏิกิริยาและการตื่นตัว",
      "Motor processing speed เวลาในการ ประมวลผลของสมองสั่งการ",
    ],
    how: (
      <div>
        <div className={styles.textgame}>
          เกมจะแสดงรูปภาพสิ่งของที่มีสีต่างๆ
        </div>
        <div className={styles.picgame1}>
          <img src={Game1} alt="Game1" className={styles.imggame1}></img>
          <img className={styles.finger} src={FingerPoint} alt="fingerPoint" />
        </div>
        <ul className={styles.ulgame1}>
          <div className={styles.bodygame1}>
            <div className={styles.bodytextgame1}>
              <span className={styles.texthl1}>กดเลข 1 </span>
              <span className={`${styles.textleft1} ${styles.red}`}>
                ถ้าสิ่งของเป็นสีแดง{" "}
              </span>
            </div>
          </div>
          <div className={styles.bodygame1}>
            <div className={styles.bodytextgame1}>
              <span className={styles.texthl1}>กดเลข 2 </span>
              <span className={`${styles.textleft1} ${styles.blue}`}>
                ถ้าสิ่งของเป็นสีน้ำเงิน{" "}
              </span>
            </div>
          </div>
          <div className={styles.bodygame1}>
            <div className={styles.bodytextgame1}>
              <span className={styles.texthl1}>กดเลข 3 </span>
              <span className={`${styles.textleft1} ${styles.green}`}>
                ถ้าสิ่งของเป็นสีเขียว{" "}
              </span>
            </div>
          </div>
        </ul>
      </div>
    ),
    howPic: <></>,
  },
  {
    gameNameTH: "การทดสอบ Stroop",
    gameNameEng: "Stroop Task",
    gamePic: <img src={brain} alt="brain" />,
    gameicon: <img src={brain} alt="brain" className={styles.gameicon} />,
    gameTarget: [
      "Inhibitory control การยับยั้งชั่งใจ",
      "Selective attention การเลือกใส่ใจ",
    ],
    how: (
      <div className={styles.textgame}>
        เกมจะแสดงคำศัพท์ที่มี “ชื่อของสี” ระบุไว้ ด้วยหมึกสีต่างชนิดกัน
        <div className={styles.picgame1}>
          <img src={Game2} alt="Game2" className={styles.imggame2} />
          <img className={styles.finger} src={FingerPoint} alt="fingerPoint" />
        </div>
        ผู้เล่นจะต้องเลือกว่า
        <br />
        <span className={styles.underlinetext}>
          คำศัพท์นั้นใช้หมึกสีอะไร
        </span>{" "}
        <span>โดยไม่สนใจชื่อของสี</span>
      </div>
    ),
    howPic: <></>,
  },
  {
    gameNameTH: "",
    gameNameEng: "Digital span backword",
    gamePic: <img src={digitalBackward} alt="digiBackward" />,
    gameicon: (
      <img
        src={digitalBackward}
        alt="digiBackward"
        className={styles.gameicon}
      />
    ),

    gameTarget: ["", ""],
    how: (
      <div className={styles.textgame}>
        <span> จำเลขที่แสดงผล และใส่ตัวเลข </span>
        <br />
        <span className={styles.underlinetext}>จากหลังไปหน้า</span>ให้ถูกต้อง
        <br />
        ภายในเวลาที่กำหนด
        <InfoGameSpandigi nums={[2, 4, 8]} renums={[8, 4, 2]} />
      </div>
    ),
    howPic: <></>,
  },
  {
    gameNameTH: "",
    gameNameEng: "Mental rotation task",
    gamePic: <img src={cube} alt="cube" />,
    gameicon: <img src={cube} alt="cube" className={styles.gameicon} />,

    gameTarget: ["", ""],
    how: (
      <div className={styles.textgame}>
        ตอบคำถามว่า ทั้ง 2 ภาพที่หมุนต่างมุมกัน
        <br />
        หากหมุนเป็นมุมเดียวกันจะเป็นภาพเดียวกันหรือไม่
        <div className={styles.spanImg}>
           <img className={styles.spanGame} src={Game5} alt="Game5"></img>
        </div>
      </div>
    ),
    howPic: <></>,
  },
  {
    gameNameTH: "",
    gameNameEng: "Wisconsin Card Sorting",
    gamePic: <img src={wisdom} alt="wisdom" />,
    gameTarget: ["", ""],
    how: (
      <div className={styles.textgamenormal}>
        <span> เลือกภาพให้ </span>{" "}
        <span className={styles.underlinetext}>ตรงตามคำสั่ง</span>
        <br />
        (รูปทรง, สี, จำนวน) ในเวลาที่กำหนด
        <div className={styles.textgame6}>เลือกภาพที่เป็น "
          <span className={styles.highlight}>สี</span>
          " เดียวกัน</div>
        <div className={styles.bodypicgame6}>
          <div className={styles.star}>
            <Star color={"#F23535"} />
          </div>
          <div className={styles.textordergame6}>ตัวเลือก:</div>
          <div className={styles.displaychoicegame6}>
            <div className={styles.twostar}>
              <Star color={"#27AE60"} />
              <Star color={"#27AE60"} />
            </div>
            <div className={styles.mountainCorrect}>
              {[0, 1, 2, 3].map((nums, index) => (
                <Mountain key={index} color={"#F23535"}></Mountain>
              ))}
            </div>
          </div>
        </div>
      </div>
    ),
    howPic: <></>,
  },
];

export const color = {
  red: "#f23535",
  blue: "#2f80ed",
  green: "#27ae60",
};
